import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ConvertJobFragmentDoc } from '../../fragment/generated/convertJob';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ConversionJobSubscriptionVariables = Types.Exact<{
  input: Types.JobSubscriptionInput;
}>;


export type ConversionJobSubscription = { job: { jobScheduleId: string, status: Types.JobEntityStatusEnum, error?: string | null, mediaUrls: Array<{ url: string, format: string }>, meta?: { lessonMeta?: { refBlockId: string, pageBlockId: string, htmlUrl: string } | null } | null } };


export const ConversionJobDocument = /*#__PURE__*/ gql`
    subscription conversionJob($input: JobSubscriptionInput!) {
  job(data: $input) {
    ...ConvertJob
  }
}
    ${ConvertJobFragmentDoc}`;

export function useConversionJobSubscription<TData = ConversionJobSubscription>(options: Omit<Urql.UseSubscriptionArgs<ConversionJobSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<ConversionJobSubscription, TData>) {
  return Urql.useSubscription<ConversionJobSubscription, TData, ConversionJobSubscriptionVariables>({ query: ConversionJobDocument, ...options }, handler);
};